import ApplicationService from "./applications";

export default class UserJwtServices {
  axiosIns = null

  jwtConfig = null

  applications = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
    this.applications = new ApplicationService(axiosIns, jwtConfig)
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}`, payload)
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.usersEndpoints}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.usersEndpoints}/${id}`)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.usersEndpoints}/${id}/update`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.usersEndpoints}/${id}`)
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.usersEndpoints}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  import(formData) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  importBioData(formData) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/bio-data/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  // P8: ends every active PAC session for the user and notifies their applications
  revokeSessions(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/sessions/revoke`, {})
  }

  deactivate(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/deactivate`, {})
  }

  resendAdminAccountConfirmationEmail(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/account/confirmation/resend`)
  }


  resetMFA(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/account/mfa/reset`)
  }

  resendAccountConfirmationEmail(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/account/confirmation/resend`)
  }

  resetUserPassword(id, payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/${id}/password/reset`, payload)
  }
}
